'use client';

import { useTranslation } from 'next-i18next';

import { Box, Link, StackProps, Text } from '@chakra-ui/react';

import { urlMap } from '@nocowanie/core/consts';

export const ResultsOrderInfo = ({ ...props }: StackProps) => {
    const { t } = useTranslation('listing', { keyPrefix: 'orderInfo' });

    const renderInfo = (isMobile: boolean) => (
        <Box
            as={'span'}
            fontSize={'sm'}
            display={{ base: isMobile ? 'inline' : 'none', md: isMobile ? 'none' : 'inline' }}
        >
            <Text as={'span'} color={'gray.700'}>
                {t(isMobile ? 'textMobile' : 'text')}
            </Text>{' '}
            <Link asChild color={'gray.700'} fontWeight={'bold'}>
                <a href={urlMap.termsOfServicePositioning} target="_blank">
                    {t(isMobile ? 'linkMobile' : 'link')}
                </a>
            </Link>
        </Box>
    );

    return (
        <Box {...props}>
            {renderInfo(true)}
            {renderInfo(false)}
        </Box>
    );
};
